import { Injectable, inject } from "@angular/core";
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateFn } from "@angular/router";
import { Account } from "@app/models/account";
import { environment } from "@environments/environment";
import { AccountService } from "./account-service";

@Injectable({
    providedIn: 'root'
  })
 export class PermissionsService {
  
    constructor(private router: Router,
                private accountService: AccountService) {}
  
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const account: Account = this.accountService.accountValue;
        if (account) {
            if (account.passwordExpired) {
                window.location.href = `${environment.tessellonPortalLoginUrl}/profile/change-password`;
                return false;
            }

            // check if route is restricted by role
            if (next.data.roles) {
                if(!next.data.roles.some(i => account.roles.includes(i))) {
                    // role not authorized so redirect to portal home page
                    window.location.href = `${environment.tessellonPortalLoginUrl}`;
                    return false;
                }
            }

            // authorized so return true
            return true;
        }

        // not logged in so redirect to login page with the return url 
        window.location.href = `${environment.tessellonPortalLoginUrl}/account/login`;
        return false;
    }
  }
  
export const AuthGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
return inject(PermissionsService).canActivate(next, state);
}